<template>
  <v-container fluid :style="{ 'background-color': pageElements[$route.name] ? '' : '' }">
    <!-- Desktop -->
    <!-- Choice Screen -->
    <v-layout v-if="this.isChoiceScreen && !this.isMobile" row wrap style="position: relative">
      <v-flex xs12>
        <v-img :src="require('@/assets/images/privately-logo.png')" height="30px" contain style="margin-top: 38px" />
      </v-flex>
      <v-container>
        <v-layout align-center justify-center height="52px" style="margin-top: 32px">
          <span
            style="
              font-family: Fredoka One;
              font-style: normal;
              font-weight: normal;
              font-size: 43px;
              line-height: 52px;
              display: flex;
              align-items: center;
              text-align: center;
              color: #18739d;
              flex: none;
              order: 3;
              flex-grow: 0;
              margin: 0px 0px;
            "
            >Welcome</span
          >
        </v-layout>
      </v-container>
      <v-container>
        <v-layout align-center justify-center>
          <span
            style="
              font-family: Varela Round;
              font-style: normal;
              font-weight: normal;
              font-size: 18px;
              width: 480px;
              line-height: 22px;
              text-align: center;
            "
          >
            Our video age verification model estimates a user's age based on a short audio-video recording
          </span>
        </v-layout>

        <v-flex xs12>
          <v-img :src="require('@/assets/images/home-img.svg')" height="65px" contain style="margin-top: 24px" />
        </v-flex>
        <v-flex xs12>
          <v-layout align-center justify-center height="24px" width="640px" style="margin-top: 36px">
            <span
              style="
                font-family: Fredoka One;
                font-style: normal;
                font-weight: normal;
                font-size: 20px;
                color: #333333;
                flex: none;
                order: 9;
                flex-grow: 0;
                line-height: 24px;
                display: flex;
                align-items: center;
                text-align: center;
              "
              >Estimate my age using
            </span>
          </v-layout>
        </v-flex>
      </v-container>
      <v-flex
        height="126px"
        width="420px"
        style="margin-top: 32px; position: absolute; left: 0%; right: 0%; top: calc(90% + 0px)"
      >
        <v-layout row align-center justify-center style="margin-top: 24px">
          <v-btn
            width="96px"
            style="border-radius: 148px; background: #18739d"
            large
            outlined
            type="submit"
            class="button is-primary"
            @click="startVideo"
          >
            <span style="color: #ffffff">Video</span>
          </v-btn>
          <v-btn
            width="96px"
            style="border-radius: 148px; background: #999999"
            large
            outlined
            type="submit"
            class="button is-primary"
          >
            <span style="color: #cccccc">Photo</span>
          </v-btn>
          <v-btn
            width="96px"
            style="border-radius: 148px; background: #999999"
            large
            outlined
            type="submit"
            class="button is-primary"
          >
            <span style="color: #cccccc">Voice</span>
          </v-btn>
        </v-layout>
        <v-layout
          style="
            min-width: 320px;
            width: 80%;
            max-width: 480px;
            margin: auto;
            position: absolute;
            left: 0%;
            right: 0%;
            top: calc(50% + 80px);
            padding: 45px 30px 30px;
            background: #6fdcff;
            align-self: center;
            border-radius: 20.125px;
          "
        >
          <span style="text-align: center">
            You will be asked to enable your camera and microphone. Your privacy and security is vitally important to
            us. For more information on how we process data, please refer to
            <a href="https://www.privately.eu/legal" target="_blank">our privacy policy </a>
          </span>
          <v-img
            :src="require('@/assets/images/privacy-icon.svg')"
            height="60px"
            width="60px"
            contain
            style="
              margin-top: 24px;
              position: absolute;
              left: calc(50% - 60px / 2);
              top: calc(50% - 130px);
              border-radius: 30px;
              background: #d5e2eb;
            "
          />
        </v-layout>
      </v-flex>
    </v-layout>
    <!-- Recording Screen -->
    <v-layout v-if="this.isRecordingScreen && !this.isMobile" row wrap>
      <v-container v-if="!this.imageProcessRunning || this.isRecording" style="position: relative">
        <v-layout column wrap style="margin-top: 0px">
          <v-img
            :src="require('@/assets/images/privately-logo.png')"
            height="30px"
            contain
            style="margin-bottom: 16px"
          />
          <progress-bar
            v-if="this.imageProcessRunning"
            :options="progressBarOptions"
            :value="progressValue"
            style="width: 100%; min-width: 320px; max-width: 640px; position: relative; align-self: center"
          />

          <video
            playsinline
            autoplay="true"
            ref="video"
            muted="true"
            style="
              width: 100%;
              min-width: 640px;
              max-width: 640px;
              min-height: 480px;
              max-height: 480px;
              align-content: center;
              transform: rotateY(180deg);
              -webkit-transform: rotateY(180deg);
              -moz-transform: rotateY(180deg);
              position: relative;
              align-self: center;
              margin-top: 0px;
            "
          ></video>
          <!-- this.$route.name -->
          <v-img
            v-if="!this.imageProcessRunning | this.isRecording && this.$route.name == 'video_age_verification_overlay'"
            v-bind:style="{
              top: this.videoComponent.top,
              width: this.videoComponent.width,
              height: this.videoComponent.height,
            }"
            style="
              width: 100%;
              min-width: 640px;
              max-width: 640px;
              align-content: center;
              min-height: 520px;
              max-height: 520px;
              position: absolute;
              align-self: center;
              margin-top: 0px;
            "
            :src="require('@/assets/images/mask.svg')"
          />

          <input
            v-if="!this.imageProcessRunning"
            type="image"
            @click="stopRecord"
            min-width="21px"
            min-height="21px"
            max-width="42px"
            max-height="42px"
            width="8%"
            style="
              position: absolute;
              top: max(10%, 80px);
              left: calc(50% + max(29%, 180px));
              align-self: flex-end;
              min-width: 21px;
              max-width: 42px;
              min-height: 21px;
              max-height: 42px;
            "
            :src="require('@/assets/images/close-button.svg')"
          />
          <!-- 150px 30px // 25% 10% -->

          <v-layout
            align-center
            justify-center
            height="52px"
            v-bind:style="{ top: this.videoOverlayPosition }"
            style="
              margin-top: 32px;
              border-radius: 16px;
              position: absolute;
              left: 0;
              right: 0;
              background: #88888888;
              margin-left: auto;
              margin-right: auto;
              width: min(600px, 75%);
            "
          >
            <span
              style="
                font-family: Fredoka One;
                width: 75%;
                font-style: normal;
                font-weight: normal;
                font-size: 24px;
                line-height: 52px;
                display: flex;
                align-items: center;
                text-align: center;
                color: #ffffff;
                flex: none;
                order: 3;
                flex-grow: 0;
                margin: 0px 0px;
              "
              >{{ this.videoOverlayText }}</span
            >
          </v-layout>
          <v-layout
            v-if="!this.imageProcessRunning"
            mt-4
            align-center
            justify-center
            style="left: 50%; right: 50%; top: 70%; position: absolute"
          >
            <v-btn
              elevation="2"
              style="width: 120px; border-radius: 148px; background: #18739d"
              large
              outlined
              type="submit"
              class="button"
              @click="recordingButton"
            >
              <span style="color: #ffffff"> Begin </span>
            </v-btn>
          </v-layout>

          <!-- <v-layout v-if="this.imageProcessRunning && !this.isRecording" style="font-size: 24; width: 122px; position:absolute; bottom:max(15%,110px); left: calc(50% - 56px);">
                                <span style="font-size: 20px; line-height: 24px; color: #ffffff;">Processing...</span>
                            </v-layout> -->
          <v-layout mtb-3 align-center justify-center style="margin-top: 20px; font-size: 24">
            <span class="text-xs-center" style="margin-left: 10px"
              >Your privacy and security is vitally important to us and no data or media is collected or stored at any
              time.</span
            >
          </v-layout>
        </v-layout>
      </v-container>
      <v-flex
        v-if="this.imageProcessRunning && !this.isRecording"
        style="position: absolute; left: calc(50% - 200px); top: calc(50% - 150px * 1.75)"
      >
        <v-card ma-5 height="100%" width="100%" min-height="300px" min-width="400px">
          <v-card-text height="500px" style="padding-top: 20%">
            <v-layout align-center justify-center>
              <v-progress-circular :size="50" indeterminate color="grey"></v-progress-circular>
            </v-layout>
            <v-card-text style="text-align: center; padding-top: 25%; font-size: 32px"> Processing </v-card-text>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Result Screen -->
    <v-layout v-if="this.isResultScreen" row wrap>
      <v-flex>
        <v-card-text>
          <v-layout column justify-center align-center style="margin-top: 20px">
            <v-img
              :src="require('@/assets/images/privately-logo.png')"
              height="30px"
              contain
              style="margin-top: 38px; position: absolute; left: 0%; right: 0%; top: 5%"
            />
          </v-layout>
        </v-card-text>
        <v-layout
          mtb-3
          align-center
          justify-center
          style="margin-top: 32px; font-size: 24; position: absolute; top: calc(12.5%); left: 0%; right: 0%"
        >
          <span class="text-xs-center" style="margin-left: 10px; color: #18739d; font-size: 43px; line-height: 52px"
            >We estimate you are</span
          >
        </v-layout>
        <v-layout
          style="
            background: #dddddd;
            position: absolute;
            border-radius: 150px;
            top: calc(25%);
            left: calc(50% - 140px);
            padding: 10px;
          "
        >
          <v-avatar size="280" style="">
            <v-img v-bind:src="this.estimationResults.image.individual[0].img" aspect-ratio="1" contain> </v-img>
          </v-avatar>
        </v-layout>

        <v-layout
          :key="componentKey"
          justify-center
          align-center
          style="width: 450px; position: absolute; top: calc(50% + 60px); left: calc(50% - 450px * 0.5 + 5px)"
        >
          <v-select
            :items="imageModels"
            label="Select Image Model"
            style="width: 50%"
            @change="transmitdata(imageItems, $event)"
          />
        </v-layout>

        <v-layout
          justify-center
          align-center
          style="
            margin-top: 50px;
            background: #6fdcff;
            width: 450px;
            height: 320px;
            position: absolute;
            top: calc(50% + 60px);
            left: calc(50% - 450px * 0.5 + 5px);
          "
        >
          <div style="font-size: 20px">
            <!-- {{this.overallResult}} -->
            <div style="font-size: 22px; padding-bottom: 10px">
              Age Range: <b>{{ this.estimationResults.overall_label }}</b
              ><br />
              Specific Age: <b>{{ this.estimationResults.specific_age }} years old</b>
            </div>
            <div style="padding-bottom: 5px">
              Image: <b>{{ this.estimationResults.image.overall.label }}</b> ({{
                this.estimationResults.image.overall.confidence
              }}%)
              <ul style="font-size: 16px">
                <li v-for="(img, ind) in this.estimationResults.image.individual">
                  Image {{ ind + 1 }}: <b>{{ img.label }}</b> ({{ img.confidence }}%)
                </li>
              </ul>
            </div>
            <div>
              Audio: <b>{{ this.estimationResults.audio.label }}</b> ({{ this.estimationResults.audio.confidence }}%)
            </div>
          </div>
        </v-layout>
        <v-layout>
          <v-btn
            elevation="2"
            style="
              background: #18739d;
              border-radius: 65px;
              width: 174px;
              height: 60px;
              position: absolute;
              top: calc(50% + 400px);
              left: calc(50% - 174px * 0.5);
            "
            large
            outlined
            type="submit"
            class="button"
            @click="tryAgain"
          >
            <span style="color: #ffffff">Try Again</span>
          </v-btn>
        </v-layout>
      </v-flex>
    </v-layout>
    <!-- PermissionBlocked Screen -->
    <v-layout v-if="this.isPermissionBlockedScreen && !this.isMobile" row wrap style="position: relative">
      <v-flex xs12>
        <v-img :src="require('@/assets/images/privately-logo.png')" height="30px" contain style="margin-top: 38px" />
      </v-flex>
      <v-container>
        <v-layout align-center justify-center height="52px" style="margin-top: 32px">
          <span
            style="
              font-family: Fredoka One;
              font-style: normal;
              font-weight: normal;
              font-size: 43px;
              line-height: 52px;
              align-items: center;
              text-align: center;
              color: #18739d;
            "
            >We can’t access your camera or microphone</span
          >
        </v-layout>
      </v-container>
      <v-container>
        <v-layout align-center justify-center>
          <span
            style="
              font-family: Varela Round;
              font-style: normal;
              font-weight: normal;
              font-size: 18px;
              width: 480px;
              line-height: 22px;
              text-align: center;
            "
          >
            Please re-enable access to microphone and camera &amp; refresh your browser in order to proceed
          </span>
        </v-layout>
        <v-layout row align-center justify-center style="margin-top: 24px">
          <v-btn
            width="96px"
            style="border-radius: 148px; background: #18739d"
            large
            outlined
            type="submit"
            class="button is-primary"
            @click="retryPermissions"
          >
            <span style="color: #ffffff">Try Again</span>
          </v-btn>
        </v-layout>
      </v-container>
      <v-flex
        height="126px"
        width="420px"
        style="margin-top: 32px; padding: 50px; position: absolute; left: 0%; right: 0%; top: calc(90% + 0px)"
      >
        <v-layout
          style="
            min-width: 320px;
            width: 80%;
            max-width: 480px;
            margin: auto;
            position: absolute;
            left: 0%;
            right: 0%;
            top: calc(50% + 80px);
            padding: 45px 30px 30px;
            background: #6fdcff;
            align-self: center;
            border-radius: 20.125px;
          "
        >
          <span style="text-align: center">
            You will be asked to enable your camera and microphone. Your privacy and security is vitally important to
            us. For more information on how we process data, please refer to
            <a href="https://www.privately.eu/legal" target="_blank">our privacy policy </a>
          </span>
          <v-img
            :src="require('@/assets/images/privacy-icon.svg')"
            height="60px"
            width="60px"
            contain
            style="
              margin-top: 24px;
              position: absolute;
              left: calc(50% - 60px / 2);
              top: calc(50% - 130px);
              border-radius: 30px;
              background: #d5e2eb;
            "
          />
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- Mobile -->

    <v-layout v-if="!this.isSupported" row wrap style="position: relative">
      <v-flex xs12>
        <v-img :src="require('@/assets/images/privately-logo.png')" height="30px" contain style="margin-top: 38px" />
      </v-flex>
      <v-container>
        <v-layout align-center justify-center height="52px" style="margin-top: 32px">
          <span
            style="
              font-family: Fredoka One;
              font-style: normal;
              font-weight: normal;
              font-size: 43px;
              line-height: 52px;
              align-items: center;
              text-align: center;
              color: #18739d;
            "
            >We do not support your device</span
          >
        </v-layout>
      </v-container>
      <v-container>
        <v-layout align-center justify-center>
          <span
            style="
              font-family: Varela Round;
              font-style: normal;
              font-weight: normal;
              font-size: 18px;
              width: 480px;
              line-height: 22px;
              text-align: center;
            "
          >
            Optimized for Chrome and Firefox to work on Windows, Linux, MacOS and Android environments.
          </span>
        </v-layout>
      </v-container>
    </v-layout>
    <!-- Choice Screen -->
    <v-layout v-if="this.isChoiceScreen && this.isMobile" row wrap style="position: relative">
      <v-flex xs12 style="margin-top: 38px">
        <v-img :src="require('@/assets/images/privately-logo.png')" height="30px" contain style="" />
      </v-flex>
      <v-container>
        <v-layout align-center justify-center height="52px" style="margin-top: 32px">
          <span
            style="
              font-family: Fredoka One;
              font-style: normal;
              font-weight: normal;
              font-size: 43px;
              line-height: 52px;
              display: flex;
              align-items: center;
              text-align: center;
              color: #18739d;
              flex: none;
              order: 3;
              flex-grow: 0;
              margin: 0px 0px;
            "
            >Welcome</span
          >
        </v-layout>
      </v-container>
      <v-container>
        <v-layout align-center justify-center>
          <span
            style="
              font-family: Varela Round;
              font-style: normal;
              font-weight: normal;
              font-size: 18px;
              width: 480px;
              line-height: 22px;
              text-align: center;
            "
          >
            Our video age verification model estimates a user's age based on a short audio-video recording
          </span>
        </v-layout>

        <v-flex xs12>
          <v-img :src="require('@/assets/images/home-img.svg')" height="65px" contain style="margin-top: 24px" />
        </v-flex>
        <v-flex xs12>
          <v-layout align-center justify-center height="24px" width="640px" style="margin-top: 36px">
            <span
              style="
                font-family: Fredoka One;
                font-style: normal;
                font-weight: normal;
                font-size: 20px;
                color: #333333;
                flex: none;
                order: 9;
                flex-grow: 0;
                line-height: 24px;
                display: flex;
                align-items: center;
                text-align: center;
              "
            >
              Estimate my age using
            </span>
          </v-layout>
        </v-flex>
      </v-container>

      <v-layout width="80%" row align-center justify-center style="margin-top: 24px">
        <v-btn
          width="5%"
          style="border-radius: 148px; background: #18739d"
          outlined
          type="submit"
          class="button is-primary"
          @click="startVideo"
        >
          <span style="color: #ffffff">Video</span>
        </v-btn>
        <v-btn
          width="5%"
          style="border-radius: 148px; background: #999999"
          outlined
          type="submit"
          class="button is-primary"
        >
          <span style="color: #cccccc">Photo</span>
        </v-btn>
        <v-btn
          width="5%"
          style="border-radius: 148px; background: #999999"
          outlined
          type="submit"
          class="button is-primary"
        >
          <span style="color: #cccccc">Voice</span>
        </v-btn>
      </v-layout>
      <v-layout
        style="
          min-width: 280px;
          width: 80%;
          max-width: 480px;
          margin: auto;
          margin-top: 10%;
          margin-bottom: 20px;
          left: 0%;
          right: 0%;
          padding: 45px 30px 30px;
          background: #6fdcff;
          align-self: center;
          border-radius: 20.125px;
        "
      >
        <span style="text-align: center; padding-bottom: 10px">
          You will be asked to enable your camera and microphone, but please note that your privacy and security is
          vitally important to us and no data or media is collected or stored at any time.
        </span>
        <v-img
          :src="require('@/assets/images/privacy-icon.svg')"
          height="60px"
          width="60px"
          contain
          style="
            margin-top: 24px;
            position: absolute;
            left: calc(50% - 60px / 2);
            top: calc(65%);
            border-radius: 30px;
            background: #d5e2eb;
          "
        />
      </v-layout>
    </v-layout>

    <!-- Recording Screen -->
    <v-layout v-if="this.isRecordingScreen && this.isMobile" row wrap>
      <v-container v-if="!this.imageProcessRunning || this.isRecording" style="position: relative">
        <v-layout column wrap style="margin-top: 0px">
          <v-img
            :src="require('@/assets/images/privately-logo.png')"
            height="30px"
            contain
            style="margin-bottom: 16px"
          />
          <progress-bar
            v-if="this.imageProcessRunning"
            :options="progressBarOptions"
            :value="progressValue"
            style="
              width: 100%;
              min-width: 320px;
              max-width: 640px;
              position: relative;
              align-self: center;
              margin-top: 16px;
            "
          />
          <video
            playsinline
            autoplay="true"
            ref="video"
            muted="true"
            style="
              width: 100%;
              min-width: 320px;
              max-width: 320px;
              min-height: 480px;
              max-height: 480px;
              align-content: center;
              transform: rotateY(180deg);
              -webkit-transform: rotateY(180deg);
              -moz-transform: rotateY(180deg);
              position: relative;
              align-self: center;
              margin-top: 0px;
            "
          ></video>

          <v-img
            v-if="!this.imageProcessRunning | this.isRecording && this.$route.name == 'video_age_verification_overlay'"
            v-bind:style="{
              top: this.videoComponent.top,
              width: this.videoComponent.width,
              height: this.videoComponent.height,
            }"
            style="
              width: 100%;
              min-width: 320px;
              max-width: 320px;
              min-height: 480px;
              max-height: 480px;
              align-content: center;
              position: absolute;
              align-self: center;
              margin-top: 0px;
            "
            :src="require('@/assets/images/mask.svg')"
          />

          <input
            v-if="!this.imageProcessRunning"
            type="image"
            @click="stopRecord"
            min-width="21px"
            min-height="21px"
            max-width="42px"
            max-height="42px"
            width="8%"
            style="
              position: absolute;
              top: 15%;
              left: calc(50% + max(21%, 120px));
              align-self: flex-end;
              min-width: 21px;
              max-width: 42px;
              min-height: 21px;
              max-height: 42px;
            "
            :src="require('@/assets/images/close-button.svg')"
          />
          <!-- 150px 30px // 25% 10% -->
          <v-layout
            align-center
            justify-center
            height="52px"
            v-bind:style="{ top: this.videoOverlayPositionMobile }"
            style="
              width: 75%;
              margin-top: 32px;
              border-radius: 16px;
              position: absolute;
              left: 15%;
              right: 15%;
              background: #88888888;
            "
          >
            <span
              style="
                font-family: Fredoka One;
                width: 75%;
                font-style: normal;
                font-weight: normal;
                font-size: 24px;
                line-height: 48px;
                display: flex;
                align-items: center;
                text-align: center;
                color: #ffffff;
                flex: none;
                order: 3;
                flex-grow: 0;
                margin: 0px 0px;
              "
              >{{ this.videoOverlayText }}</span
            >
          </v-layout>
          <v-layout
            v-if="!this.imageProcessRunning"
            mt-4
            align-center
            justify-center
            style="left: 50%; right: 50%; top: 53%; position: absolute"
          >
            <v-btn
              elevation="2"
              style="width: 120px; border-radius: 148px; background: #18739d"
              large
              outlined
              type="submit"
              class="button"
              @click="recordingButton"
            >
              <span style="color: #ffffff"> Begin </span>
            </v-btn>
          </v-layout>

          <!-- <v-layout v-if="this.imageProcessRunning && !this.isRecording" style="font-size: 24; width: 122px; position:absolute; bottom:max(15%,110px); left: calc(50% - 56px);">
                                <span style="font-size: 20px; line-height: 24px; color: #ffffff;">Processing...</span>
                            </v-layout> -->
          <v-layout mtb-3 align-center justify-center style="margin-top: 20px; font-size: 24">
            <span class="text-xs-center" style="margin-left: 10px"
              >Your privacy and security is vitally important to us and no data or media is collected or stored at any
              time.</span
            >
          </v-layout>
        </v-layout>
      </v-container>
      <v-flex
        v-if="this.imageProcessRunning && !this.isRecording"
        style="position: absolute; left: calc(12%); top: 20%"
      >
        <v-card ma-5 height="100%" width="100%" min-height="200px" min-width="300px">
          <v-card-text height="500px" style="padding-top: 20%">
            <v-layout align-center justify-center>
              <v-progress-circular :size="50" indeterminate color="grey"></v-progress-circular>
            </v-layout>
            <v-card-text style="text-align: center; padding-top: 25%; font-size: 32px"> Processing </v-card-text>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex sm12 md3> </v-flex>
    </v-layout>

    <!-- Result Screen -->

    <!-- PermissionBlocked Screen -->
    <v-layout v-if="this.isPermissionBlockedScreen && this.isMobile" row wrap style="position: relative">
      <v-flex xs12 style="margin-top: 38px">
        <v-img :src="require('@/assets/images/privately-logo.png')" height="30px" contain style="" />
      </v-flex>
      <v-container>
        <v-layout align-center justify-center height="52px" style="margin-top: 32px">
          <span
            style="
              font-family: Fredoka One;
              font-style: normal;
              font-weight: normal;
              font-size: 43px;
              line-height: 52px;
              align-items: center;
              text-align: center;
              color: #18739d;
            "
            >We can’t access your camera or microphone</span
          >
        </v-layout>
      </v-container>
      <v-container>
        <v-layout align-center justify-center>
          <span
            style="
              font-family: Varela Round;
              font-style: normal;
              font-weight: normal;
              font-size: 18px;
              width: 480px;
              line-height: 22px;
              text-align: center;
            "
          >
            Please re-enable access to microphone and camera &amp; refresh your browser in order to proceed
          </span>
        </v-layout>
        <v-layout row align-center justify-center style="margin-top: 24px">
          <v-btn
            width="96px"
            style="border-radius: 148px; background: #18739d"
            large
            outlined
            type="submit"
            class="button is-primary"
            @click="retryPermissions"
          >
            <span style="color: #ffffff">Try Again</span>
          </v-btn>
        </v-layout>
      </v-container>
      <v-flex height="126px" width="420px">
        <v-layout
          style="
            min-width: 320px;
            width: 80%;
            max-width: 480px;
            margin: auto;
            margin-top: 5%;
            margin-bottom: 20px;
            left: 0%;
            right: 0%;
            padding: 45px 30px 30px;
            background: #6fdcff;
            align-self: center;
            border-radius: 20.125px;
          "
        >
          <span style="text-align: center; padding-bottom: 10px">
            You will be asked to enable your camera and microphone, but please note that your privacy and security is
            vitally important to us and no data or media is collected or stored at any time.
          </span>
          <v-img
            :src="require('@/assets/images/privacy-icon.svg')"
            height="60px"
            width="60px"
            contain
            style="
              margin-top: 24px;
              position: absolute;
              left: calc(50% - 60px / 2);
              top: calc(62%);
              border-radius: 30px;
              background: #d5e2eb;
            "
          />
        </v-layout>
      </v-flex>
    </v-layout>
    <a ref="videoDownload" download />
  </v-container>
</template>

<script>
import _ from "lodash";
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import VueRecord from "@codekraft-studio/vue-record";
import Task from "@/components/common/Task.vue";
import Infobox from "@/components/common/Infobox.vue";
import unknown from "@/assets/images/unknown.jpg";
import Worker from "worker-loader!@/components/classification/worker.js";
import ProgressBar from "vuejs-progress-bar";
import styles from "@/assets/css/styles.css";

Vue.use(ProgressBar);
Vue.use(VueRecord);

const Recorder = function (source, cfg) {
  var config = cfg || {};
  var bufferLen = config.bufferLen || 4096;
  this.context = source.context;
  this.node = this.context.createScriptProcessor(bufferLen, 2, 2);

  // Create the worker
  console.log(document.documentURI);
  var worker = new Worker("/components/classification/worker.js");

  // Tell the worker to initialise
  worker.postMessage({
    command: "init",
    config: {
      sampleRate: this.context.sampleRate,
    },
  });

  var recording = false,
    currCallback;

  // As we receive audio, pass it to the worker for processing
  this.node.onaudioprocess = function (e) {
    if (!recording) return;
    worker.postMessage({
      command: "record",
      buffer: [e.inputBuffer.getChannelData(0), e.inputBuffer.getChannelData(1)],
    });
  };

  this.configure = function (cfg) {
    for (var prop in cfg) {
      if (cfg.hasOwnProperty(prop)) {
        config[prop] = cfg[prop];
      }
    }
  };

  this.record = function () {
    recording = true;
  };

  this.stop = function () {
    recording = false;
  };

  this.clear = function () {
    worker.postMessage({ command: "clear" });
  };

  this.getBuffer = function (cb) {
    currCallback = cb || config.callback;
    worker.postMessage({ command: "getBuffer" });
  };

  // Sample method to export the audio stream as a WAV file
  // using the worker
  this.exportWAV = function (cb, type) {
    currCallback = cb || config.callback;
    type = type || config.type || "audio/wav";
    if (!currCallback) {
      throw new Error("Callback not set");
    }
    worker.postMessage({
      command: "exportWAV",
      type: type,
    });
  };

  worker.onmessage = function (e) {
    var blob = e.data;
    currCallback(blob);
  };

  source.connect(this.node);
  this.node.connect(this.context.destination); //this should not be necessary
};

export default {
  data() {
    return {
      isMobile: false,
      isSupported: true,
      isRecording: false,
      audioStopped: false,
      audioData: "",
      language: "English",
      text: "",
      loading: true,
      displayResult: false,
      recordingButtonString: "Begin Recording",
      imageProcessRunning: false,
      estimationResults: {},
      overallResult: "",
      overallConfidence: 0,
      imageItems: [],
      imageResults: [],
      recordedChunks: [],
      audioRecorder: null,
      audioResultLabel: undefined,
      audioResultConfidence: undefined,
      videoOverlayText: "Please follow the instructions when the recording starts",
      videoOverlayPosition: "33%",
      videoOverlayPositionMobile: "20%",
      progressBarOptions: "",
      progressValue: 0,
      videoComponent: {
        width: "0px",
        height: "0px",
        top: "0px",
      },
      constraints: {
        video: true,
      },
      recordingConstraints: {
        audio: true,
        // video: true
        video: { width: { ideal: 640 }, height: { ideal: 480 } },
      },
      isChoiceScreen: true,
      isRecordingScreen: false,
      isResultScreen: false,
      isPermissionBlockedScreen: false,
      ageRanges: {
        childhood: "0 - 7",
        puberty: "8 - 12",
        adolescence: "13 - 17",
        early_adulthood: "18 - 24",
        adulthood: "25 - 34",
        middle_age: "35 - 50",
        seniority: "50+",
      },
      errorCodes: {
        no_face_detected: "No Face Detected",
        single_face_detected: "ingle Face Detected",
        multiple_faces_detected: "Multiple Faces Detected",
        mask_detected: "Face Mask Detected",
      },
      imageModels: ["manjot-layers-frozen", "onur-all-layers", "pavel-mobilenetv2face", "remi-pytorch"],
      componentKey: 0,
    };
  },
  mounted() {
    this.isMobile = navigator.userAgent.indexOf("Mobile") != -1;
    console.log("query:", this.$route.query);
    console.log("query:", this.$route.query["foo"]);
    if (this.$route.query["foo"] !== "undefined") {
      console.log("found foo:");
    }
  },
  components: { Task, Infobox },
  computed: {
    ...mapGetters("labeling", {}),
    ...mapGetters("common", {
      pageElements: "pageElements",
      interactInfos: "interactInfos",
    }),
    languages() {
      if (this.$route.name === "hate_toxicity") {
        return ["English", "French", "German - Swiss German", "Swiss German"];
      } else {
        return ["English"];
      }
    },
    _() {
      return _;
    },
    icon() {
      return "";
    },
  },
  methods: {
    forceRerender() {
      this.componentKey++;
    },
    tryAgain() {
      this.isResultScreen = false;
      this.isRecordingScreen = true;
      this.progressValue = 0;
      this.audioStopped = false;
      this.imageResults = [];
      this.recordedChunks = [];
      this.videoOverlayText = "Please say the following phrase to the camera";
      this.videoOverlayPosition = "33%";
      this.videoOverlayPositionMobile = "25%";
      setTimeout(() => {
        const video = document.querySelector("video");
        navigator.mediaDevices
          .getUserMedia(this.recordingConstraints)
          .then((stream) => {
            video.srcObject = stream;
          })
          .catch((error) => {
            console.log("Error Here", error);
            this.isRecordingScreen = false;
            this.isPermissionBlockedScreen = true;
          });
      }, 500);
    },
    clearText() {
      this.text = "";
    },
    retryPermissions() {
      this.isPermissionBlockedScreen = false;
      this.isChoiceScreen = true;
    },
    reloadVideo() {
      this.loading = false;
      // this.displayResult = false
      this.progressValue = 0;
      this.isResultScreen = false;
      this.imageProcessRunning = false;
      this.isRecordingScreen = true;
      this.imageProcessCounter = 5;
      this.audioStopped = false;
      this.imageResults = [];
      this.recordedChunks = [];
      setTimeout(() => {
        const video = document.querySelector("video");
        navigator.mediaDevices
          .getUserMedia(this.recordingConstraints)
          .then((stream) => {
            video.srcObject = stream;
          })
          .catch((error) => {
            console.log("Error Here", error);
            this.isRecordingScreen = false;
            this.isPermissionBlockedScreen = true;
          });
      }, 500);
    },
    startVideo() {
      this.isChoiceScreen = false;
      this.isRecordingScreen = true;
      this.progressValue = 0;
      if (this.hasGetUserMedia()) {
        setTimeout(() => {
          const video = document.querySelector("video");
          navigator.mediaDevices
            .getUserMedia(this.recordingConstraints)
            .then((stream) => {
              video.srcObject = stream;
              this.stream = stream;
              this.progressBarOptions = {
                text: {
                  color: "#ff0000",
                  shadowEnable: true,
                  shadowColor: "#000000",
                  fontSize: 14,
                  fontFamily: "Helvetica",
                  dynamicPosition: false,
                  hideText: true,
                },
                progress: {
                  color: "#33C5F2",
                  backgroundColor: "#18739D",
                  inverted: false,
                },
                layout: {
                  height: 16,
                  width: video.offsetWidth,
                  // width: 640,
                  verticalTextAlign: 61,
                  horizontalTextAlign: 43,
                  zeroOffset: 0,
                  strokeWidth: 30,
                  progressPadding: 0,
                  type: "line",
                },
              };
              console.log(video.offsetTop);
              console.log(video.offsetWidth);
              console.log(video.offsetHeight);
              console.log(video.videoHeight);
              console.log(this.$refs.video);
              this.videoComponent.top = video.offsetTop - 20 + "px";
              this.videoComponent.width = video.offsetWidth + "px";
              this.videoComponent.height = video.offsetHeight + "px";
            })
            .catch((error) => {
              console.log("Error Here", error);
              this.isRecordingScreen = false;
              this.isPermissionBlockedScreen = true;
            });
        }, 500);
        setTimeout(() => {
          const video = document.querySelector("video");
          console.log(video.offsetTop);
          console.log(video.offsetWidth);
          console.log(video.offsetHeight);
          console.log(video.videoHeight);
          this.videoComponent.top = video.offsetTop - 20 + "px";
          this.videoComponent.width = video.offsetWidth + "px";
          this.videoComponent.height = video.offsetHeight + "px";
        }, 1500);
      } else {
        console.log("Errors Abound");
      }
    },
    hasGetUserMedia() {
      return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
    },
    onVideoStream(stream) {
      console.log("STREAM");
      this.isRecording = true;
      this.$refs.video.srcObject = stream;
      // setTimeout(videoAutoStop, 5000, this.$refs.videoRecorder);
    },
    stopRecord() {
      (this.isRecordingScreen = false),
        // this.isResultScreen = true
        (this.isChoiceScreen = true);
    },
    recordingButton() {
      const videoRecorder = document.querySelector("video");
      if (this.isRecording) {
        this.isRecording = false;
        this.videoComponent.top = videoRecorder.offsetTop - 20 + "px";
      } else {
        this.videoComponent.top = videoRecorder.offsetTop + "px";

        this.imageProcessRunning = true;
        this.isRecording = true;
        this.imageItems = [];
        const video = document.querySelector("video");
        const canvas = document.createElement("canvas");

        this.videoOverlayText = "Read : E-L-E-P-H-A-N-T 🐘";
        this.videoOverlayPosition = "15%";
        this.videoOverlayPositionMobile = "14%";

        var audioContext = window.AudioContext || window.webkitAudioContext;
        if (audioContext) {
          var context = new AudioContext();
          var mediaStreamSource = context.createMediaStreamSource(this.stream);

          this.audioRecorder = new Recorder(mediaStreamSource);
          this.audioRecorder.record();
        }
        let timerId = setInterval(() => {
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          canvas.getContext("2d").drawImage(video, 0, 0);
          var imageItem = canvas.toDataURL("image/jpeg");
          this.imageItems.push(imageItem);
          // this.progressValue += 20
        }, 1000);
        setTimeout(() => {
          clearInterval(timerId);
          this.isRecording = false;
          this.stopRecording();
        }, 5500);

        // improved progress bar transitioning
        let timerId2 = setInterval(() => {
          this.progressValue += 0.1;
        }, 5);
        setTimeout(() => {
          clearInterval(timerId2);
        }, 5500);
      }
    },
    async stopRecording() {
      this.audioRecorder.stop();
      this.audioRecorder.exportWAV((stream) => {
        var ref = this;
        var reader = new FileReader();

        reader.onload = function () {
          var b64 = reader.result.replace(/^data:.+;base64,/, "");
          ref.audioData = b64;
          ref.transmitdata(ref.imageItems, null);
        };
        reader.readAsDataURL(stream);

        // // Create the blob and pass it to the player
        // let audioCapture = window.URL.createObjectURL(stream);
        // this.audioData = stream;
        // audio.src = audioCapture;
        // Submit the gathered data to the backend/processing script
      });
      // .then(()=>{

      // });
    },
    async transmitdata(imageData, selectedImageModel) {
      var cleanStr = "data:image/jpeg;base64,";
      console.log("data:audio/wav;base64," + this.audioData);

      // url params:
      var models = {
        image: selectedImageModel
          ? selectedImageModel
          : this.$route.query["image-model"]
          ? this.$route.query["image-model"]
          : null,
        audio: this.$route.query["audio-model"] ? this.$route.query["audio-model"] : null,
        svm: this.$route.query["svm-model"] ? this.$route.query["svm-model"] : null,
      };

      for (var i = 0; i < 5; i++) {
        this.imageItems[i] = this.imageItems[i].replace(cleanStr, "");
      }

      var requestsUrl = ""; // if no dev requests URL specified, use relative URL (same host)
      if (typeof process.env.VUE_APP_REQUESTS_HOST !== "undefined") {
        requestsUrl = process.env.VUE_APP_REQUESTS_HOST; // specified dev requests URL
      } else if (location.host.includes("localhost")) {
        requestsUrl = "http://localhost:5001"; // default dev requests URL
      }
      requestsUrl += "/margin/";

      var requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", "Access-Control-Allow-Origin": "*" },
      };
      if (this.$route.name == "video_age_verification" || this.$route.name == "video_age_verification_overlay") {
        requestsUrl += "video-age-verification";
        requestOptions["body"] = JSON.stringify({
          images: imageData,
          audio: "" + this.audioData,
          models: models,
        });
      } else if (this.$route.name == "video_age_verification_pytorch") {
        requestsUrl += "video-age-verification-pytorch";
        requestOptions["body"] = JSON.stringify({
          images: imageData,
          audio: "" + this.audioData,
        });
      } else if (this.$route.name == "face_detection") {
        requestsUrl += "detect-faces";
        requestOptions["body"] = JSON.stringify({
          images: imageData,
        });
      } else if (this.$route.name == "mask_detection") {
        requestsUrl += "detect-masks";
        requestOptions["body"] = JSON.stringify({
          images: imageData,
        });
      }

      fetch(requestsUrl, requestOptions)
        .then(async (response) => {
          const response_payload = await response.json();

          if (this.$route.name == "face_detection") {
            if (response_payload.meta.status == "success") {
              var data = response_payload.data;
              var strData = "Results:\n";
              console.log(data.length);
              for (var i = 0; i < data.length; i++) strData += "Image " + i + ": " + this.errorCodes[data[i]] + "\n";
              console.log("data:", data[i]);
              alert(strData);
            } else {
              alert(response_payload.error.code);
            }
            this.reloadVideo();
            return;
          }

          if (this.$route.name == "mask_detection") {
            if (response_payload.meta.status == "success") {
              var data = response_payload.data;
              console.log(data);
              alert("Result: " + this.errorCodes[data]);
            } else {
              alert(response_payload.error.code);
            }
            this.reloadVideo();
            return;
          }

          // check for error response
          if (!response.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || response.status;
            // this.displayResult = false
            this.isResultScreen = false;
            this.loading = false;
            this.imageProcessRunning = false;
            console.log("error:", error);
            return Promise.reject(error);
          }
          var meta = response_payload.meta;
          if (response_payload.meta.status == "success") {
            var data = response_payload.data;

            // overall results
            this.estimationResults["overall_label"] = this.ageRanges[data.overall_label];
            this.estimationResults["specific_age"] = data.specific_age_estimation.toFixed(1);

            // image results
            this.estimationResults["image"] = {};
            this.estimationResults["image"]["overall"] = {
              label: this.ageRanges[data.image.overall.label],
              confidence: String((data.image.overall.confidence * 100).toFixed(1)),
            };

            this.estimationResults["image"]["individual"] = [];
            for (var i = 0; i < data.image["individual"].length; i++) {
              var imageItem = {};
              if (data.image["individual"][i].status == "success") {
                imageItem = {
                  img: "data:image/png;base64," + data.image["individual"][i].img,
                  label: this.ageRanges[data.image["individual"][i].label],
                  confidence: String((data.image["individual"][i].confidence * 100).toFixed(1)),
                };
              } else if (data.image["individual"][i].status == "error") {
                imageItem = {
                  img: unknown,
                  label: "-",
                  confidence: "No face detected",
                };
              }
              this.estimationResults["image"]["individual"].push(imageItem);
            }

            // audio results
            this.estimationResults["audio"] = {};
            if (data.audio.status == "success") {
              this.estimationResults["audio"]["label"] = this.ageRanges[data.audio.label];
              this.estimationResults["audio"]["confidence"] = (data.audio.confidence * 100).toFixed(1);
            }
            if (data.audio.status == "error") {
              this.estimationResults["audio"]["label"] = "-";
              this.estimationResults["audio"]["confidence"] = "No speech detected";
            }

            // logging debug outputs:
            console.log("data:", data);
            console.log(`Age Range Estimate: ${this.estimationResults["overall_label"]} years`);
            console.log(`Specific Age Estimate: ${this.estimationResults["specific_age"]} years old`);

            for (var i = 0; i < this.estimationResults["image"]["individual"].length; i++) {
              console.log(
                `Image ${i} - Age Range Estimate: ${this.estimationResults["image"]["individual"][i].label}; Confidence: ${this.estimationResults["image"]["individual"][i].confidence}`
              );
            }

            console.log(
              `Audio - Age Range Estimate: ${this.estimationResults["audio"]["label"]}; Confidence: ${this.estimationResults["audio"]["confidence"]}`
            );

            this.loading = false;
            // this.displayResult = true
            this.isResultScreen = true;
            this.isRecordingScreen = false;
            this.imageProcessRunning = false;

            // iFrame CODE SNIPPET
            var pass_data = {
              age_identified: this.overallResult,
              score: this.overallConfidence,
              verified: "true",
            };
            parent.postMessage(JSON.stringify(pass_data), "*");
          } else if (response_payload.meta.status == "error") {
            if (response_payload.error.code == "no_face_detected") {
              alert("No faces were detected - make sure your video camera is on and you're looking at it.");
            } else if (response_payload.error.code == "multiple_faces_detected") {
              alert("Multiple faces were detected - make sure you're the only one front of the camera.");
            } else if (
              response_payload.error.code == "spoof_detected" ||
              response_payload.error.code == "insufficient_brightness"
            ) {
              alert(
                "Poor image quality. Please change your position to your light source and make sure that you are in a sufficiently illuminated place"
              );
            } else if (response_payload.error.code == "image_too_blurry") {
              alert(
                "The image is too blurry/out of focus. Please make sure you're remaining still and your camera lens is clean."
              );
            } else if (response_payload.error.code == "mask_detected") {
              alert("Face mask detected - please remove your mask before taking a recording.");
            } else if (response_payload.error.code == "no_valid_images") {
              alert("No faces were detected - make sure your video camera is on and you're looking at it.");
            } else if (response_payload.error.code == "general_error") {
              alert("An error occurred while analyzing your video - please try again.");
            } else if (response_payload.error.code == "no_sound_detected") {
              alert(
                "No sound was detected - please make sure your microphone is properly enabled and you speak clearly during the recording."
              );
            } else if (response_payload.error.code == "invalid_image_model") {
              alert("Invalid image model name");
            } else if (response_payload.error.code == "invalid_audio_model") {
              alert("Invalid audio model name");
            } else if (response_payload.error.code == "invalid_svm_model") {
              alert("Invalid SVM model name");
            }

            console.log("error:", response_payload.error.code);
            this.reloadVideo();
          }

          return data;
        })
        .then(() => {
          if (selectedImageModel) {
            this.forceRerender();
          }
        });
    },
    async onResult(data) {
      this.isRecording = false;
      this.imageProcessRunning = false;
      this.$refs.video.srcObject = undefined;
      const resultValue = window.URL.createObjectURL(data, { type: "video/mpeg" });
      this.$refs.video.src = resultValue;
      var reader = new FileReader();
      var ref = this;
      reader.onload = function () {
        var b64 = reader.result.replace(/^data:.+;base64,/, "");
        ref.loading = true;
        ref.processVideo(b64);
      };
      reader.readAsDataURL(data);
      setTimeout(() => {
        window.URL.revokeObjectURL(resultValue);
      }, 1000);
      this.$refs.video.src = resultValue;
    },
    onProcessResult: async (result) => {},
  },
};
</script>

<style scoped>
.overlayCircle {
  position: relative;
  margin-top: 0px;
}
</style>
